import {Box, Image, Spinner, Text, VStack} from '@chakra-ui/react';
import {useEffect} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {useApi} from '@/haligator-factory';
import {useTranslation} from 'react-i18next';
import {useClientRoute} from '@/hooks/auth/useClientRoute';
import {LOGO_FF_COULEUR_URL} from '@/domains/mediatheque/logoFFCouleurUrl';
import {imageOptimisee} from '@/domains/mediatheque/optimisation';
import {
  PAIEMENT_1P6_ERROR_REDIRECT_DELAY_MS,
  routes,
  usePaiement1p6Traitement,
} from 'ff-common';
import {BlueButton} from '@/components/Button/BlueButton';

export const Paiement1p6Page: React.FC = () => {
  const [searchParams] = useSearchParams();
  const panier_id = searchParams.get('panier_id');
  const navigate = useNavigate();
  const api = useApi();
  const {t} = useTranslation('common');
  const {buildClientRoute} = useClientRoute();

  const {pageState} = usePaiement1p6Traitement({
    api,
    panier_id,
    onSuccess: (event) => {
      navigate(
        buildClientRoute(
          routes.client.panier_default,
          {},
          {derniereAction: 'valide', logique: event.data.data.logique},
        ),
      );
    },
  });

  useEffect(() => {
    if (pageState !== 'error') return;
    const timer = setTimeout(() => {
      navigate(buildClientRoute(routes.client.panier_default));
    }, PAIEMENT_1P6_ERROR_REDIRECT_DELAY_MS);
    return () => {
      clearTimeout(timer);
    };
  }, [pageState, navigate, buildClientRoute]);

  return (
    <Box
      display='flex'
      justifyContent='center'
      alignItems='center'
      height='100vh'
      bg='gray.50'
    >
      <VStack
        gap='6'
        textAlign='center'
        p='8'
        bg='white'
        borderRadius='lg'
        shadow='md'
        maxW='md'
      >
        <Image
          src={imageOptimisee(LOGO_FF_COULEUR_URL, 150)}
          alt={t('global.alt_logo_france_frais')}
          maxWidth='150px'
          mb={2}
        />
        {pageState === 'loading' && (
          <>
            <Spinner
              size='xl'
              color='blue.500'
            />
            <Text
              fontSize='lg'
              fontWeight='600'
            >
              {t('panier.paiement.traitement_en_cours')}
            </Text>
            <Text color='gray.500'>{t('panier.paiement.ne_pas_fermer')}</Text>
          </>
        )}
        {pageState === 'error' && (
          <>
            <Spinner
              size='xl'
              color='blue.500'
            />
            <Text
              fontSize='lg'
              fontWeight='600'
              color='red.500'
            >
              {t('panier.paiement.transaction_echouee')}
            </Text>
            <Text color='gray.600'>
              {t('panier.paiement.redirection_panier')}
            </Text>
            <BlueButton
              onClick={() =>
                navigate(buildClientRoute(routes.client.panier_default))
              }
              texte={t('panier.paiement.retour_panier')}
            />
          </>
        )}
      </VStack>
    </Box>
  );
};
